<template>
  <vx-card title="Our Partner">

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2">
        <vs-input
          label="Title ID"
          v-model="data.titleId"
          class="w-full"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <vs-input
          label="Title EN"
          v-model="data.titleEn"
          class="w-full"
        />
      </div>
    </div>

    <draggable :list="data.itemList" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move mb-5" @end="saveChanges">
      <img
        v-for="(listItem, index) in data.itemList"
        :key="index" closable
        @click="remove(index)"
        :src="listItem.imageUrl"
        style="max-width: 150px; display: inline; margin-right: 15px;"
        title="Klik gambar untuk menghapus"
      />
    </draggable>

    <upload-image
      @upload-success="data.itemList.push({ imageUrl: $event })"
      label="Image"
      class="mb-5"
    />

    <div class="vx-row text-right">
      <div class="vx-col text-right">
        <div class="vx-col w-full">
          <vs-button
            icon="save"
            @click="saveChanges"
          >Save</vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    computed: {
      data() {
        return this.$store.state.page.data.homeOurPartners || { itemList: [] }
      }
    },
    components: { draggable },
    methods: {
      selectCategoryChange(val) {
        this.data.itemList.push(val)
        this.saveChanges()
      },
      saveChanges () {
        this.$store.dispatch('page/set', this.data)
      },
      remove (index) {
        this.data.itemList.splice(index, 1)
        this.saveChanges()
      }
    }
  }
</script>
